import { Theme, makeStyles, createStyles } from "@material-ui/core";

export const useMapStyles = makeStyles((theme: Theme) =>
  createStyles({
    settings: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(2),
      "& .MuiTextField-root": {
        marginLeft: 0,
      },
    },
  })
);
